//return Hard accelaration value
export const getHardAccelerationTime = (data) => {
  if (
    data.hardAccelerationTimes !== null &&
    data.hardAccelerationTimes >= 0
  ) {
    if (data.hardAccelerationTimes > 1) {
      return data.hardAccelerationTimes + " times";
    } else {
      return data.hardAccelerationTimes + " time";
    }
  } else {
    return "na";
  }
}

//return Hard braking value
export const gethardBrakingTimes = (data) => {
  if (
    data.hardBrakingTimes !== null &&
    data.hardBrakingTimes >= 0
  ) {
    if (data.hardBrakingTimes > 1) {
      return data.hardBrakingTimes + " times";
    } else {
      return data.hardBrakingTimes + " time";
    }
  } else {
    return "na";
  }
}